export const WEATHER_MODULE_NAME = "weather";
export const FARM_LANDS_WEATHER_MODULE_NAME = "farmLandsWeather";
export const FARM_LANDS_TECH_MODULE_NAME = "farmLandsTech";
